import React from "react";

export default function CampaignSettingsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.691"
      height="16.667"
      viewBox="0 0 16.691 16.667"
    >
      <g
        id="Icon_-_Campaign_Settings"
        data-name="Icon - Campaign Settings"
        transform="translate(0 0.001)"
      >
        <path
          id="Icon_-_Campaign_Settings-2"
          data-name="Icon - Campaign Settings"
          d="M19448.5,23531.666a1.5,1.5,0,0,1-1.508-1.5v-1.582a1.508,1.508,0,0,1,1.508-1.506h5.373v-1.459h-5.373a1.5,1.5,0,0,1-1.508-1.5v-1.578a1.506,1.506,0,0,1,1.508-1.506h5.373v-1.457h-5.373a1.5,1.5,0,0,1-1.508-1.5v-1.584a1.5,1.5,0,0,1,1.508-1.494h12a1.5,1.5,0,0,1,1.494,1.494v1.584a1.5,1.5,0,0,1-1.494,1.5h-5.375v1.457h5.375a1.5,1.5,0,0,1,1.494,1.506v.484a5.411,5.411,0,0,0-2.5-.6,6,6,0,0,0-.887.07h-9.738v1.666h6.615a5.486,5.486,0,0,0-1.494,3.768,5.716,5.716,0,0,0,.035.609h-5.156v1.67h5.617a5.489,5.489,0,0,0,.973,1.453v.006Zm.371-13.541h11.25v-1.672h-11.25Zm11.6,13.223-.3-.52a3.2,3.2,0,0,1-1.156,0l-.3.52a.447.447,0,0,1-.549.2,4.183,4.183,0,0,1-1.174-.68.46.46,0,0,1-.1-.578l.3-.521a3.087,3.087,0,0,1-.584-1h-.6a.46.46,0,0,1-.449-.377,4.165,4.165,0,0,1,0-1.357.461.461,0,0,1,.449-.379h.6a3.135,3.135,0,0,1,.584-1l-.3-.52a.452.452,0,0,1,.1-.578,4.28,4.28,0,0,1,1.174-.68.447.447,0,0,1,.549.2l.3.52a3.38,3.38,0,0,1,1.156,0l.3-.52a.447.447,0,0,1,.549-.2,4.28,4.28,0,0,1,1.174.68.459.459,0,0,1,.1.578l-.3.52a3.135,3.135,0,0,1,.584,1h.6a.456.456,0,0,1,.449.371,4.289,4.289,0,0,1,0,1.359.465.465,0,0,1-.449.383h-.6a3.087,3.087,0,0,1-.584,1l.3.521a.453.453,0,0,1-.1.578,4.183,4.183,0,0,1-1.174.68.5.5,0,0,1-.158.027A.44.44,0,0,1,19460.475,23531.348Zm-1.844-2.676a1.365,1.365,0,0,0,1.932-1.926,1.581,1.581,0,0,0-.967-.357A1.355,1.355,0,0,0,19458.631,23528.672Z"
          transform="translate(-19446.996 -23515)"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
